import { Standort } from '@/domain/mitarbeiter/features/rotationsplan/entities/Standort';
import { cn } from '@/lib/utils';
import { faLocationDot } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HTMLAttributes } from 'react';

export function Location({
  standort,
  className,
  ...others
}: { standort: Standort } & HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        `text-neutrals-700 flex gap-1 justify-start items-center text-xs`,
        className,
      )}
      {...others}>
      <FontAwesomeIcon icon={faLocationDot} />
      <span className="whitespace-nowrap truncate">
        {standort.storenummer && <>{standort.storenummer} - </>}
        {standort.name}
      </span>
    </div>
  );
}
